import {log} from "@helpers";
import {buildUrlParams} from "@helpers";

const conteudoViewerText = async (url, p, reIndex) => {
  try {
    const queryObj = {url};
    if (p !== null) {
      queryObj.p = p;
    }
    if (reIndex !== null) {
      queryObj.reIndex = reIndex;
    }

    const queryString = buildUrlParams(queryObj);

    const payload = await fetch(
      `${process.env.REACT_APP_API_V2}/v3/clientes/conteudoViewerText?${queryString}`
    );

    log("conteudoViewerText", payload);

    return await payload.text();
  } catch (e) {
    log(e);
    return "error";
  }
};

export default conteudoViewerText;
